import type { ReactNode } from "react";
import type { ContactMetier } from "models";
import { Grid, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ActionType, useContactMetierActions } from "providers";

interface ContactActionsCellProps {
  contactMetier: ContactMetier;
  dense?: boolean;
}

function ContactActionsCell({
  contactMetier,
  dense = false,
}: Readonly<ContactActionsCellProps>): ReactNode {
  const { openActionDialog } = useContactMetierActions();

  return (
    <Grid container direction="column" size="auto" sx={{ pr: 1 }}>
      <IconButton
        color="info"
        size="small"
        onClick={() => {
          openActionDialog(ActionType.EDIT, contactMetier);
        }}
        sx={dense ? { marginTop: "-2px", marginBottom: "-2px" } : undefined}>
        <Tooltip title="Modifier" placement="left">
          <EditIcon />
        </Tooltip>
      </IconButton>
      <IconButton
        color="error"
        size="small"
        onClick={() => {
          openActionDialog(ActionType.DELETE, contactMetier);
        }}
        sx={dense ? { marginTop: "-2px", marginBottom: "-2px" } : undefined}>
        <Tooltip title="Supprimer" placement="left">
          <DeleteIcon />
        </Tooltip>
      </IconButton>
    </Grid>
  );
}

export default ContactActionsCell;
